export function IncomeBridgePanel({ income }: { income: Record<string, unknown> }) {
  const status = income.status;
  if (status === 'insufficient') {
    return <section className="rounded-[10px] border border-border bg-card p-4" aria-labelledby="income-heading"><h2 id="income-heading" className="font-semibold">2. Income</h2><p className="mt-2 text-sm text-muted-foreground">USD only · {String(income.excluded_count ?? 'some')} rows excluded</p></section>;
  }
  return (
    <section className="rounded-[10px] border border-border bg-card p-4" aria-labelledby="income-heading">
      <h2 id="income-heading" className="font-semibold">2. Income</h2>
      <dl className="mt-3 space-y-2 text-sm">
        <div className="flex justify-between"><dt>Deposits</dt><dd>{String(income.deposits ?? 'No amount reported')}</dd></div>
        <div className="flex justify-between"><dt>Cash reported</dt><dd>{income.cash == null ? 'No amount reported' : String(income.cash)}</dd></div>
        {(income.exclusions as Array<{ kind: string; amount: string; reason: string }> | undefined)?.map((exclusion) => <div key={`${exclusion.kind}-${exclusion.amount}`} className="flex justify-between text-muted-foreground"><dt>Less · {exclusion.reason}</dt><dd>{exclusion.amount}</dd></div>)}
        <div className="flex justify-between border-t border-border pt-2 font-semibold"><dt>Gross receipts</dt><dd>{income.gross_receipts == null ? 'No amount reported' : String(income.gross_receipts)}</dd></div>
      </dl>
    </section>
  );
}

export default IncomeBridgePanel;
